module.exports = __webpack_public_path__ + "static/media/close-eye-icon.3b048743.svg";